import React, { useEffect, useState } from "react";
import { Box, Typography, Switch, Button, Stack } from "@mui/material";
import { CustomDiv } from "./Sidebar";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import Dropdown from "./Dropdown";
import NewApiSB from "./NewApiSB";
import LockIcon from "@mui/icons-material/Lock";
import {
  fetchAndSaveSubscriptionsFromServer,
  getSubscribedProductNames,
} from "../../payment/SubscriptionInfo";
// import DrawingBoard from "./DrawingBoard";
interface componentProps {
  err: boolean;
  isDimensioned: boolean;
}
const FloorPlanSection: React.FC<componentProps> = (props) => {
  const { floorPlans, loading, isError, error, pollingProgress } = useSelector(
    (state: RootState) => state.graph,
  );
  const plotWidth = useSelector(
    (state: RootState) => state.nodesState.selectedPlotWidth,
  );
  const plotHeight = useSelector(
    (state: RootState) => state.nodesState.selectedPlotHeight,
  );

  const [showBoundary, setShowBoundary] = useState<boolean>(false);

  const [WEB_FRONTEND_ACCESS, setWebFrontendAccess] = useState(false);

  const handleToggle = () => {
    setShowBoundary(!showBoundary);
  };

  useEffect(() => {
    console.log(isError);
  }, [isError]);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      let subscribedProducts = getSubscribedProductNames();
      if (!subscribedProducts || subscribedProducts.length === 0) {
        try {
          subscribedProducts = await fetchAndSaveSubscriptionsFromServer();
        } catch (err) {
          subscribedProducts = [];
        }
      }
      setWebFrontendAccess(subscribedProducts.includes("Web Frontend"));
    };
    fetchSubscriptions();
  }, []);


  return (
    <Box id="test" sx={{ flex: 15, position: "relative" }}>
      <CustomDiv>
        {WEB_FRONTEND_ACCESS && props.isDimensioned ? (
          <Box
            className="container2 plan"
            sx={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              pb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 15,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "#FF9A56",
                    fontSize: "16px",
                    fontWeight: 600,
                    pr: 1,
                  }}
                >
                  Boundary
                </Typography>
                <Switch
                  checked={
                    plotHeight !== 0 && plotWidth !== 0 ? showBoundary : false
                  }
                  onChange={handleToggle}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#FF9A56",
                      "&:hover": {
                        backgroundColor: "rgba(28, 76, 130, 0.08)",
                      },
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#FF9A56",
                    },
                  }}
                />
              </Box>

              {loading && (
                pollingProgress
                  ? <>{pollingProgress.description} ({pollingProgress.current}/{pollingProgress.total})</>
                  : <>Generating ....</>
              )}
              {!loading && isError && (
                <>{error || "Cannot Generate FloorPlans. Please Try again later."}</>
              )}
              {!isError && (
                <NewApiSB
                  isDimensioned={props.isDimensioned}
                  showBoundary={showBoundary}
                />
              )}
            </Box>
          </Box>
        ) : !props.isDimensioned ? (
          <Box
            className="container2 plan"
            sx={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              pb: 2,
            }}
          >
            <Dropdown />
            {/* Plan */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 15,
              }}
            >
              {loading && (
                pollingProgress
                  ? <>{pollingProgress.description} ({pollingProgress.current}/{pollingProgress.total})</>
                  : <>Generating ....</>
              )}
              {!loading && isError && (
                <>{error || "Cannot Generate FloorPlans. Please Try again later."}</>
              )}
              {!isError && (
                <NewApiSB
                  isDimensioned={props.isDimensioned}
                  showBoundary={showBoundary}
                />
              )}
            </Box>
          </Box>
        ) : (
          <Box
            className="container2 plan"
            sx={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              // Flexbox specifically for centering the content
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // Visual enhancements for the "Locked" look
              zIndex: 10, // Ensure it sits on top of content
              backgroundColor: "rgba(251, 229, 198, 0.8)", // Semi-transparent white
              backdropFilter: "blur(4px)", // Optional: blurs the content behind
            }}
          >
            {/* Stack acts as the centered div holding the elements */}
            <Stack spacing={2} alignItems="center">
              <LockIcon sx={{ fontSize: 60, color: "text.secondary" }} />

              <Typography variant="h5" fontWeight="bold" color="text.primary">
                Subscribe to unlock
              </Typography>

              <Typography variant="body1" color="text.secondary">
                Upgrade your plan to view this content.
              </Typography>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#FF9A56",
                  color: "#1a1a1a",
                  border: "2px solid #1a1a1a",
                  borderRadius: "12px",
                  fontWeight: 700,
                  // boxShadow: "4px 4px 0px #1a1a1a",
                  "&:hover": {
                    backgroundColor: "#e8894d",
                    transform: "translate(-2px, -2px)",
                    // boxShadow: "6px 6px 0px #1a1a1a",
                  },
                  "&:active": {
                    transform: "translate(1px, 1px)",
                    // boxShadow: "2px 2px 0px #1a1a1a",
                  },
                }}
                size="large"
                href="/plans"
              >
                See Plan
              </Button>
            </Stack>
          </Box>
        )}
      </CustomDiv>
    </Box>
  );
};

export default FloorPlanSection;
